import { merge, of, Subject } from 'rxjs';
import {
	filter, mergeMap, switchMap, takeUntil,
} from 'rxjs/operators';

import { Container, Service } from '../../../../symphony';

import { SlActions } from './sl-actions';
import { SlActionsController } from './sl-actions.controller';
import { IAction, ActionType, RequestType } from '../../global-interface';
import { lePlaygroundContext } from '../../global-constants';

@Service()
export class SlActionsService {
	private actions$ = Container.take(lePlaygroundContext.value, SlActions).actions$;

	private controller = Container.take(
		lePlaygroundContext.value,
		SlActionsController,
	);

	private cancelableActionsMap = {};

	private parallelActionsMap = {
		[ActionType.OnHeaderCompileBtnCLick]:
			this.controller.onHeaderCompileBtnCLickHandler,
		[ActionType.OnHeaderChangeModeToggle]:
			this.controller.onHeaderChangeModeToggleHandler,
		[ActionType.OnMaterialNotFoundClick]:
			this.controller.onMaterialNotFoundClickHandler,
		[ActionType.InitPlayground]: this.controller.initPlaygroundHandler,
		[ActionType.MakeFreeze]: this.controller.makeFreezeHandler,
		[ActionType.ResetContainer]: this.controller.resetContainerHandler,
		[ActionType.OnCloseConsoleClick]:
			this.controller.onCloseConsoleClickHandler,
		[ActionType.OpenConsole]: this.controller.openConsoleHandler,
		[ActionType.OnConsoleClick]: this.controller.onConsoleClickHandler,
		[ActionType.onCloseModalSaveBtnClick]:
			this.controller.onCloseModalSaveBtnClickHandler,
		[ActionType.onCloseModalDiscardBtnClick]:
			this.controller.onCloseModalDiscardBtnClickHandler,
		[ActionType.GetMaterial]: this.controller.getMaterialHandler,
		[ActionType.SolveMaterial]: this.controller.solveMaterialHandler,

		[ActionType.Track]: this.controller.onTrackActionHandler,
	};

	constructor() {
		const unsubscriber: Subject<void> = Container.take(
			lePlaygroundContext.value,
			'unsubscriber',
		);
		const cancelable = this.actions$.pipe(
			filter((a) => !!a && a.requestType === RequestType.Cancelable),
			switchMap((action: IAction) => {
				const handler = this.cancelableActionsMap[action.type];
				return handler ? handler(action.data) : of(action);
			}),
		);

		const parallel = this.actions$.pipe(
			filter((a) => !!a && a.requestType === RequestType.Parallel),
			mergeMap((action: IAction) => {
				const handler = this.parallelActionsMap[action.type];
				return handler ? handler(action.data) : of(action);
			}),
		);

		merge(cancelable, parallel)
			.pipe(
				filter((a) => !!a),
				takeUntil(unsubscriber),
			)
			.subscribe();
	}
}
